import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {TranslatePipe} from "@ngx-translate/core";
import {DragScrollDirective} from "../../../directives/drag-scroll.directive";

@Component({
  selector: 'app-map-toggle-bar',
  templateUrl: './map-toggle-bar.component.html',
  styleUrls: ['./map-toggle-bar.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    DragScrollDirective
  ],
  standalone: true
})

export class MapToggleBarComponent {
  @Input() type: string = '';
  @Input() activeSegment: string = 'posts';
  @Output() selectedLabel: EventEmitter<string> = new EventEmitter<string>();

  onSegmentChange(ev: CustomEvent): void {
    const value = ev.detail.value as string;
    this.selectedLabel.emit(value);
  }
}
